import capitalizeFirstCharacter from "../utils/capitalizeFirstCharacter";
import filter_params from "../utils/filter_params";

/* GROUP BY project X group */

const groupDataByTwoParameters = (input_array, fc1, fc2, fc1_array, fc2_array) => {

      console.log("inside groupDataByTwoParameters | fc1_array : " + fc1_array + "  | fc2_array : " + fc2_array)

      let temp_array = []
      let fc1_counts_array_template = fc1_array.map ( fc1_i => {
            let fc2_counts_map_template = initiateCountObject(fc2_array)
            console.log('fc2_counts_map_template: ' + JSON.stringify(fc2_counts_map_template))
            let y ={}
            y['name'] = fc1_i
            y['allocation_counts'] = {...fc2_counts_map_template}
            temp_array.push(y)
      })

      console.log("temp_array inside groupDataByTwoParameters BEFORE ITERATION:" + JSON.stringify(temp_array));

      // input_array.map( i => {
      //       if(i.Project__r != null) {
      //             if(i.Project__r.Name != null) {
      //                   if(temp_array.find(ta => ta.name ==i.Project__r.Name)) {
      //                         temp_array.find(ta => ta.name ==i.Project__r.Name)['allocation_counts'][i[filter_params[fc2]]]++
      //                   }
      //             }
      //       }
      // })
      input_array.map( i => {
            if(i[filter_params[fc1][0]] != null) {
                  if(i[filter_params[fc1][0]].Name != null) {
                        if(temp_array.find(ta => ta.name ==i[filter_params[fc1][0]].Name)) {
                              temp_array.find(ta => ta.name ==i[filter_params[fc1][0]].Name)['allocation_counts'][i[filter_params[fc2]]]++
                        }
                  }
            }
      })

      console.log("temp_array inside groupDataByTwoParameters AFTER ITERATION:" + JSON.stringify(temp_array));

      return temp_array

      // let final_charts_array = []
      // let axis_names = []
      // // axis_names.push(capitalizeFirstCharacter(fc1))
      // axis_names.push(fc1)
      // fc2_array.map(fc2_i => {
      //       axis_names.push(fc2_i)
      //       axis_names.push({ role: "annotation", type: "string" })
      // })
      
      // final_charts_array.push(axis_names)
      
      // temp_array.map (ta_i => {
      //       let values_array = []
      //       values_array.push(ta_i.name)
      //       fc2_array.map(fc2_i => {
      //             values_array.push(ta_i.allocation_counts[fc2_i])
      //             values_array.push(ta_i.allocation_counts[fc2_i] ? ta_i.allocation_counts[fc2_i].toString() : 0) /* for annotation*/
      //       })
      //       final_charts_array.push(values_array)
      // })
      
      // console.log("final_charts_array:" + JSON.stringify(final_charts_array));

      // return final_charts_array;
};


function initiateCountObject(fc2_array) {
      let arr = {}
      fc2_array.map ( fc2_i => {
                  console.log('fc2_i: ' + fc2_i)
                  arr[fc2_i] = 0
            })
      return arr
}

export default groupDataByTwoParameters;





// Template....

// [
//       {'name': 'Eynesbury' , 'allocationcounts' : { 'a': 0 , 'b' : 0}},
//       {'name': 'Eynesbury' , 'allocationcounts' : { 'a': 0 , 'b' : 0}},
//       {'name': 'Eynesbury' , 'allocationcounts' : { 'a': 0 , 'b' : 0}},
// ]
